<template>
  <div class="introduction section" id="introduction">
    <div class="layout-content">
      <SubTitle :text="data.title" :subText="data.subTitle" />

      <div class="l-content">
        <div class="content-bg">
          <div class="left">
            <p :class="`left-text-${index}`" v-for="(p, index) in data.intro" :key="index" v-html="p"></p>
          </div>
          <div class="right">
            <i class="bofang" @click="playHandler(data.video)"></i>
            <div class="img-wrap">
              <div class="mask"></div>
              <img class="img-video" :src="data.poster" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SubTitle from '@/components/SubTitle'
import * as GlobalLayer from '@/utils/globalLayer'

export default {
  props: ['data'],
  components: {
    SubTitle
  },
  methods: {
    playHandler (video) {
      GlobalLayer.createModal(this.$store, {
        video
      })
    }
  }
}
</script>

<style lang="scss" scoped>

.introduction {
  padding-top: 80px;
  background: $bgGrey;

  @include mobile {
    padding-top: 25px;
  }
}

.layout-content {

  @include mobile {
    margin-top: 0;
  }
}

.l-content {
  display: flex; flex-direction: column; justify-content: space-between; align-items: center;

  @include mobile {
    // display: none;
  }
}

.content-bg {
  box-sizing: border-box;
  display: flex; flex-direction: column; align-items: center;
  width: 1200px; height: 826px;
  padding: 54px 70px 80px;
  background: #FFFFFF;

  @include mobile {
    width: 100%; height: auto;
    padding: 0;
    background: none;
  }
}

.left {
  width: 1060px;
  margin-bottom: 60px;
  text-align: justify;
  font-size: 16px; font-weight: 400;
  color: #000000;
  line-height: 30px;

  @include mobile {
    width: 100%;
    margin-bottom: 20px;
    color: #000000;
    font-size: 14px; font-weight: 400;
    line-height: 28px;
  }
}

.left-text-0 {
  margin-bottom: 30px;

  @include mobile {
    margin-bottom: 16px;
  }
}

.right {
  width: 804px; height: 452px;
  position: relative;
  transform: translateX(15px);

  @include mobile {
    width: 100%; height: 188px;
    margin: 0 auto;
    transform: none;
  }

  i {
    $val: 50px;
    width: $val; height: $val;
    position: absolute; z-index: 10;
    @include absoluteCenter;
    display: block;
    background: url('https://static001.geekbang.org/resource/image/ef/69/efd0026a21de3da79eb68b8cb8a07969.png') center / cover no-repeat;
    cursor: pointer;
  }

  .img-wrap {
    $padding-top-bottom: 20px;
    $padding-left-right: 30px;
    width: 100%; height: 100%;
    padding: $padding-top-bottom $padding-left-right;
    position: relative;

    @include mobile {
      height: 188px;
    }

    img {
      width: 100%; height: 100%;
    }

    // .mask {
    //   position: absolute; top: $padding-top-bottom; right: $padding-left-right; bottom: $padding-top-bottom; left: $padding-left-right;
    //   background-color: rgba(#000, 0.3);
    // }

    .img-video {
      position: absolute; top: 0; right: 0; bottom: 0; left: 0;
      width: 804px; height: 452px;

      @include mobile {
        width: 100%; height: 188px;
      }
    }
  }
}

</style>
